<template>
    
</template>
<script>
import * as memberApi from '@/api/member'
import * as  authApi from "@/utils/auth.js"
export default {
    created(){
        console.log(this.$route.query.token)
        if(this.$route.query.token){
            localStorage.setItem("token",this.$route.query.token)            
            memberApi.info().then(res=>{
                console.log(res)
                if(res.code === 200){
                    authApi.setInfo(res.data)
                    this.$router.push('/')
                }
            })
        }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/oauth.vue